import { Injectable } from '@angular/core';
import { Sakota } from '@creately/sakota';
import { AbstractCommand, Command, CommandService, Random } from 'flux-core';
import { Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { DiagramCommandEvent } from '../../../editor/diagram/command/diagram-command-event';
import { DiagramLocatorLocator } from '../../diagram/locator/diagram-locator-locator';
import { EDataLocatorLocator } from '../locator/edata-locator-locator';
import { EntityListModel } from '../model/entity-list.mdl';
import { EDataCommandEvent } from './edata-command-event';

@Injectable()
@Command()
export class GenerateSaveSet extends AbstractCommand {
    public data: {
        eDataId: string;
        entityIds: string[];
        definedSearchQuery: string,
        setName: string;
    };

    constructor(
        private ll: DiagramLocatorLocator,
        private ell: EDataLocatorLocator,
        private commandSvc: CommandService,
        ) {
        super();
    }

    execute(): boolean | Observable<any> {
        return this.createSmartSet( this.data.setName );
    }

    protected getDiagramModel() {
        return this.ll.forCurrentObserver( false ).pipe(
            take( 1 ),
            switchMap( locator => locator.getDiagramOnce()),
        );
    }

    protected createSmartSet( name: string ) {
        return this.getDiagramModel().pipe(
            switchMap( diagram => {
                const eDataId = this.data.eDataId;
                const definedSearchQuery = this.data.definedSearchQuery;
                return this.ell.getEDataModel( eDataId ).pipe(
                    tap( eDataModel => {
                        const entityListId = Random.entityListId();
                        const eDataSakotaModel = Sakota.create( eDataModel );
                        const newEntityListModel = new EntityListModel( entityListId, eDataModel.defId );
                        newEntityListModel.search = definedSearchQuery;
                        newEntityListModel.name = name;
                        if ( !eDataModel.entityLists ) {
                            eDataSakotaModel.entityLists = {};
                        }
                        eDataSakotaModel.entityLists[entityListId] = newEntityListModel;
                        newEntityListModel.entities = this.data.entityIds;
                        const dModel = Sakota.create( diagram );
                        this.commandSvc.dispatch( EDataCommandEvent.applyModifierEDataUser, eDataId, {
                            modifier: eDataSakotaModel.__sakota__.getChanges(),
                        });
                        this.commandSvc.dispatch( DiagramCommandEvent.applyModifierDocument, diagram.id, {
                            modifier: dModel.__sakota__.getChanges(),
                        });
                    }),
                );
            }),
        );
    }
}


Object.defineProperty( GenerateSaveSet, 'name', {
    value: 'GenerateSaveSet',
});
